import { performanceSimpleScoreChart } from './performanceNodes';

const performanceSection = (data, lang = 'en') => {
  // TODO calculate chart type here as this is used when saving to report

  let chart_type = 'HorizontalBarChart';

  for (var x = 0; x < data.performanceData.length; x++) {
    if (data.performanceData[x][1]) {
      if (
        data.performanceData[x][1]['client_question_analysis'] &&
        data.performanceData[x][1]['client_question_analysis']['time_series_scores'] &&
        data.performanceData[x][1]['client_question_analysis']['time_series_scores'].length
      ) {
        chart_type = 'HorizontalLineChart';
        break;
      }

      if (
        data.performanceData[x][1]['client_question_analysis'] &&
        data.performanceData[x][1]['client_question_analysis']['unique_sentiments_count'] &&
        data.performanceData[x][1]['client_question_analysis']['unique_sentiments_count']['data']
      ) {
        for (
          var y = 0;
          y <
          data.performanceData[x][1]['client_question_analysis']['unique_sentiments_count']['data']
            .length;
          y++
        ) {
          if (
            data.performanceData[x][1]['client_question_analysis']['unique_sentiments_count'][
              'data'
            ][y][7] &&
            data.performanceData[x][1]['client_question_analysis']['unique_sentiments_count'][
              'data'
            ][y][7].length
          ) {
            chart_type = 'HorizontalLineChart';
            break;
          }
        }
      }
    }
  }
  const performanceChart = performanceSimpleScoreChart(
    data.performanceTitle,
    data.performanceData,
    lang,
    data.performanceThreshold,
    chart_type,
    '',
    '',
    '',
    '',
    false,
    data.performanceMode,
    data.performanceSentimentMode,
  );

  return {
    type: 'section',
    id: 'performance-section',
    content: [performanceChart],
    meta: {
      performanceUUID: data.performanceUUID,
      subTitle: 'PERFORMANCE ANALYSIS',
    },
  };
};

export { performanceSection };
